import React, { Component } from 'react'
import './Style.scss'
import Helper from '../Helper';

export class TextOverImage extends Component {

    render() {
        var content = this.props.blogSectionObj;
        var theme = this.props.theme
        const handleErrorImageLoading = ({ currentTarget }) => {
            currentTarget.onerror = null; // prevents looping
            currentTarget.src = content.attributes.fallbackImageUrl ? content.attributes.fallbackImageUrl : "";
        }
        return (
            <>
                <div className={`banner-image-textOverImg banner-image col-md-12 col-sm-12 col-lg-12 col-12`} style={{position : 'relative', textAlign : 'center'}}>

                    {/* <Link to={content && content.attributes && content.attributes.mainImageUrl ? content.attributes.mainImageUrl : ""}> */}
                        <img src={content.mainImage ? content.mainImage : ""} onError={handleErrorImageLoading} className='img-fluid' alt={content.attributes.altText} />
                    {/* </Link> */}
                    <div className="banner-text-textOverImg" style={{position : 'absolute', top : '50%', left : '50%', transform : 'translate(-50%, -50%)'}}>
                        <h3 className={`banner-text mobile-banner-text ${content.attributes && content.attributes.titleCss}`}  id={Helper.labelMerger(content.attributes.title)}>{content?.attributes?.title}</h3>
                        <div className="banner-text-1 mobile-banner-text-1" dangerouslySetInnerHTML={{ __html: content.body }}></div>
                    </div>
                    {theme.horizontalRuler == 'true' ? <hr className='mx-5'></hr> : ""}

                </div>
            </>
        )
    }

}

export default TextOverImage
